<template>
  <div class="card">
    <h3>实验结果数据回传接口</h3>
    <p>回传数据接口适用于用户完成实验教学项目后，产生的实验结果数据回传到平台。如果有实验报告，则先调用数据回传接口，然后再上传实验报告附件。</p>
    <h4>接口调用请求说明</h4>
    <p>http请求方式：POST <a href="javascript:void(0)">http://xa.celer.cc.com/open/data_upload?ticket=3d337d7bcf3e85b85e8adeac36d21f93be673f********************************************e90cfb677d67c922a916738dc7e3f84db3db7d2ce</a>
    </p>
    <h4>请求示例</h4>
    <json-viewer
      class="code"
      :value="jsonData"
    ></json-viewer>
    <h4>JSON字段说明</h4>
    <table class="param_table">
      <tr>
        <td>
          <h4>键值</h4>
        </td>
        <td>
          <h4>类型</h4>
        </td>
        <td>
          <h4>是否必须</h4>
        </td>
        <td>
          <h4>说明</h4>
        </td>
      </tr>
      <tr>
        <td>username</td>
        <td>String</td>
        <td>否</td>
        <td>平台用户账号</td>
      </tr>
      <tr>
        <td>status</td>
        <td>Int</td>
        <td>是</td>
        <td>实验状态：1 - 完成；0 - 未完成</td>
      </tr>
      <tr>
        <td>score</td>
        <td>Int</td>
        <td>是</td>
        <td>实验成绩：0 ~100，百分制</td>
      </tr>
      <tr>
        <td>startTime</td>
        <td>Time</td>
        <td>是</td>
        <td>实验开始时间：13位时间戳</td>
      </tr>
      <tr>
        <td>endTime</td>
        <td>Time</td>
        <td>是</td>
        <td>实验结束时间：13位时间戳</td>
      </tr>
      <tr>
        <td>timeUsed</td>
        <td>Int</td>
        <td>是</td>
        <td>实验用时：非零整数，单位秒</td>
      </tr>
      <tr>
        <td>appid</td>
        <td>Int</td>
        <td>否</td>
        <td>接入平台编号：由平台分配给实验教学项目的编号</td>
      </tr>
      <tr>
        <td>originId</td>
        <td>String</td>
        <td>否</td>
        <td>实验平台实验记录ID：平台唯一</td>
      </tr>
      <tr>
        <td>remarks</td>
        <td>String</td>
        <td>否</td>
        <td style="width: 480px;">
          <div>备注：由实验生成的任意字符串，可以包含html标记，显示在平台查看实验成绩功能下方。</div>
          <div>例如：remarks: '文本1&lt;br&gt;&lt;span style="color: blue"&gt;文本3&lt;/span&gt;&lt;br&gt;&lt;table&gt;&lt;tr&gt;&lt;td&gt;表格1&lt;/td&gt;&lt;td&gt;表格2&lt;/td&gt;&lt;/tr&gt;&lt;tr&gt;&lt;td&gt;表格3&lt;/td&gt;&lt;td&gt;表格4&lt;/td&gt;&lt;/tr&gt;&lt;/table&gt;'</div>
          <div>显示如下：</div>
          <div style="border: 1px dotted #CCCCCC">
            文本1<br><span style="color: blue">文本3</span><br><table><tr><td>表格1</td><td>表格2</td></tr><tr><td>表格3</td><td>表格4</td></tr></table>
          </div>
        </td>
      </tr>
      <tr>
        <td>steps</td>
        <td>Array</td>
        <td>是</td>
        <td>实验步骤记录：详见《实验步骤记录》说明</td>
      </tr>
    </table>

    <h4>实验步骤记录</h4>
    <table class="param_table">
      <tr>
        <td>
          <h4>键值</h4>
        </td>
        <td>
          <h4>类型</h4>
        </td>
        <td>
          <h4>是否必须</h4>
        </td>
        <td>
          <h4>说明</h4>
        </td>
      </tr>
      <tr>
        <td>seq</td>
        <td>Int</td>
        <td>是</td>
        <td>实验步骤序号</td>
      </tr>
      <tr>
        <td>title</td>
        <td>String</td>
        <td>是</td>
        <td>步骤名称：100字以内</td>
      </tr>
      <tr>
        <td>startTime</td>
        <td>Time</td>
        <td>是</td>
        <td>实验步骤开始时间：13位时间戳</td>
      </tr>
      <tr>
        <td>endTime</td>
        <td>Time</td>
        <td>是</td>
        <td>实验步骤结束时间：13位时间戳</td>
      </tr>
      <tr>
        <td>timeUsed</td>
        <td>Int</td>
        <td>是</td>
        <td>实验步骤用时：非零整数，单位秒</td>
      </tr>
      <tr>
        <td>expectTime</td>
        <td>Int</td>
        <td>是</td>
        <td>实验步骤合理用时：单位秒</td>
      </tr>
      <tr>
        <td>maxScore</td>
        <td>Int</td>
        <td>是</td>
        <td>实验步骤满分：0 ~100，百分制</td>
      </tr>
      <tr>
        <td>score</td>
        <td>Int</td>
        <td>是</td>
        <td>实验步骤得分：0 ~100，百分制</td>
      </tr>
      <tr>
        <td>repeatCount</td>
        <td>Int</td>
        <td>是</td>
        <td>实验步骤操作次数</td>
      </tr>
      <tr>
        <td>evaluation</td>
        <td>String</td>
        <td>是</td>
        <td>步骤评价：200字以内</td>
      </tr>
      <tr>
        <td>scoringModel</td>
        <td>String</td>
        <td>是</td>
        <td>赋分模型：200字以内</td>
      </tr>
      <tr>
        <td>remarks</td>
        <td>String</td>
        <td>是</td>
        <td>备注：200字以内</td>
      </tr>
    </table>
    <h4>调用URL示例</h4>
    <p>http://xa.celer.cc/open/data_upload?ticket=3d337d7bcf3e85b85e8adeac36d21f93be673f********************************************e90cfb677d67c922a916738dc7e3f84db3db7d2ce</p>
    <h4>返回结果</h4>
    <p>正确时的返回JSON数据包如下：</p>
    <json-viewer
      class="code"
      :value="jsonData1"
    ></json-viewer>
    <p>
      错误时的返回JSON数据包如下（示例为参数缺失）：
    </p>
    <json-viewer
      class="code"
      :value="jsonData2"
    ></json-viewer>
    <h4>返回码说明：</h4>
    <table class="param_table">
      <tr>
        <td>
          <h4>返回码</h4>
        </td>
        <td>
          <h4>说明</h4>
        </td>
      </tr>
      <tr>
        <td>0</td>
        <td>成功</td>
      </tr>
      <tr>
        <td>1</td>
        <td>参数错误</td>
      </tr>
      <tr>
        <td>2</td>
        <td>非法 ticket</td>
      </tr>
      <tr>
        <td>3</td>
        <td>ticket 已过期</td>
      </tr>
      <tr>
        <td>4</td>
        <td>非法 ticket[U]</td>
      </tr>
      <tr>
        <td>5</td>
        <td>非法 ticket[E]</td>
      </tr>
      <tr>
        <td>6</td>
        <td>非法 ticket[ES]</td>
      </tr>
      <tr>
        <td>7</td>
        <td>数据错误，appid 与 ticket 所含信息不一致</td>
      </tr>
      <tr>
        <td>8</td>
        <td>数据错误，用户信息与 ticket 不一致</td>
      </tr>
      <tr>
        <td>9</td>
        <td>实验步骤错误</td>
      </tr>
      <tr>
        <td>10</td>
        <td>实验步骤不得超出 200 步</td>
      </tr>
      <tr>
        <td>11</td>
        <td>实验结果应为0[未完成]或1[已完成]</td>
      </tr>
      <tr>
        <td>12</td>
        <td>实验成绩应为整数</td>
      </tr>
      <tr>
        <td>13</td>
        <td>实验开始时间错误</td>
      </tr>
      <tr>
        <td>14</td>
        <td>实验结束时间错误</td>
      </tr>
      <tr>
        <td>15</td>
        <td>实验用时应为整数</td>
      </tr>
      <tr>
        <td>15</td>
        <td>实验平台实验记录ID错误</td>
      </tr>
      <tr>
        <td>21</td>
        <td>实验步骤序号填写错误</td>
      </tr>
      <tr>
        <td>22</td>
        <td>步骤名称填写错误</td>
      </tr>
      <tr>
        <td>23</td>
        <td>实验步骤开始时间错误</td>
      </tr>
      <tr>
        <td>24</td>
        <td>实验步骤结束时间错误</td>
      </tr>
      <tr>
        <td>25</td>
        <td>实验步骤用时填写错误</td>
      </tr>
      <tr>
        <td>26</td>
        <td>实验步骤合理用时填写错误</td>
      </tr>
      <tr>
        <td>27</td>
        <td>实验步骤满分填写错误</td>
      </tr>
      <tr>
        <td>28</td>
        <td>实验步骤得分填写错误</td>
      </tr>
      <tr>
        <td>29</td>
        <td>实验步骤操作次数填写错误</td>
      </tr>
      <tr>
        <td>30</td>
        <td>步骤评价数填写错误</td>
      </tr>
      <tr>
        <td>31</td>
        <td>赋分模型填写错误</td>
      </tr>
      <tr>
        <td>32</td>
        <td>备注不能超过200字</td>
      </tr>
    </table>

  </div>
</template>

<script>
export default {
  name: 'DataUpload',
  data: function () {
    return {
      jsonData: {
        username: 'li_sh',
        status: 1,
        score: 80,
        startTime: 1522646936000,
        endTime: 1522647936000,
        timeUsed: 900,
        appid: 3,
        originId: 1,
        remarks: '文本1<br>文本2<br><span style="color: blue">文本3</span><br><table><tr><td>表格1</td><td>表格2</td></tr><tr><td>表格3</td><td>表格4</td></tr></table>',
        steps: [
          {
            seq: 1,
            title: '实验步骤 1',
            startTime: 1522646936000,
            endTime: 1522647936000,
            timeUsed: 900,
            expectTime: 2,
            maxScore: 10,
            score: 10,
            repeatCount: 1,
            evaluation: '优',
            scoringModel: '赋分模型',
            remarks: '备注'
          },
          {
            seq: 2,
            title: '实验步骤 2',
            startTime: 1522646936000,
            endTime: 1522647936000,
            timeUsed: 900,
            expectTime: 2,
            maxScore: 90,
            score: 85,
            repeatCount: 1,
            evaluation: '优',
            scoringModel: '赋分模型',
            remarks: '备注'
          }
        ]
      },
      jsonData1: {
        code: 0,
        id: '1'
      },
      jsonData2: {
        code: 1,
        msg: '参数错误'
      }
    }
  }
}
</script>

<style scoped>
.card {
  border: 1px solid #eee;
  padding: 20px;
  width: 100%;
  background-color: #fff;
  border-radius: 5px;
  box-sizing: border-box;
}

p {
  word-wrap: break-word;
  word-break: break-all;
}

a {
  word-wrap: break-word;
  word-break: break-all;
}

div {
  word-wrap: break-word;
  word-break: break-all;
}

.param_table {
  width: 800px;
}

.param_table tr td {
  border-bottom: 1px solid #ddd;
  padding: 7px;
}

.param_table tr td:first-child {
  width: 150px;
  text-align: left;
  vertical-align: top;
}

.param_table tr:last-child td {
  border-bottom: none;
}

.code {
  width: 1000px;
  padding: 7px;
  border-radius: 5px;
  border: 1px solid #aaa;
  background-color: #eee;
  margin-bottom: 15px;
}

.jv-container.jv-light {
  background: #eee;
}

h3,
h4,
h5 {
  margin-top: 20px;
  margin-bottom: 10px;
}
</style>
